<div class="avatar-image-holder" [class.small]="fullSizeAvatar !== size" [class.square]="square">
  <div [class.done]="!loading" [ngStyle]="avatar ? {'background-image': 'url(' + avatar + ')'} : false" class="cover gradient-loading"></div>
  <img *ngIf="avatar" (error)="handleImageError()" (load)="handleImageLoad()" [src]="avatar" loading="lazy" />
</div>
